export default "__VITE_ASSET__7ff52b56__"